import { render, staticRenderFns } from "./TeacherIndividualYearlyAttendancePage.vue?vue&type=template&id=34318462&scoped=true&"
import script from "./TeacherIndividualYearlyAttendancePage.vue?vue&type=script&lang=js&"
export * from "./TeacherIndividualYearlyAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34318462",
  null
  
)

export default component.exports